// extracted by mini-css-extract-plugin
export default {"imageContainer":"D2-z","summaryPar":"E2-z","ratingCategories":"F2-z","reviewerInfo":"G2-z","reviewTypes":"H2-z","expanded":"I2-z"};